// Need to remove once all the hotkeys are migrated to Angular

import { Component, OnInit, OnDestroy, Renderer2, NgZone, inject } from '@angular/core';
import { HotkeysService } from 'angular2-hotkeys';
import { MonEventService } from '@monsido/ng2/services/mon-event/mon-event.service';
import { MON_EVENTS } from '@monsido/ng2/core/constants/mon-events.constant';


@Component({
    selector: 'unified-hotkeys-cheatsheet',
    templateUrl: './unified-hotkeys-cheatsheet.component.html',
    styleUrls: ['./unified-hotkeys-cheatsheet.component.scss'],
    standalone: false,
})
export class UnifiedHotkeysCheatsheetComponent implements OnInit, OnDestroy {
    private _hotkeysInterval: any;
    showCheatsheet: boolean = false;
    allHotkeys: { combo: string, description: string }[] = [];
    private removeListener: (() => void) | null = null;
    ngZone = inject(NgZone);

    constructor (
        private readonly hotkeysService: HotkeysService,
        private readonly renderer: Renderer2,
        private readonly monEventService: MonEventService,
    ) {}

    ngOnInit () {
        this.removeListener = this.renderer.listen('document', 'keydown', (e: KeyboardEvent) => {
            if (this.showCheatsheet && e.key === 'Escape') {
                this.closeCheatsheet();
                e.preventDefault();
                e.stopImmediatePropagation();
                return;
            }
            const tag = (e.target as HTMLElement)?.tagName?.toLowerCase();
            if (tag === 'input' || tag === 'textarea' || tag === 'select') {
                return;
            }
            if (e.key === '?' || (e.shiftKey && e.key === '/')) {
                e.stopImmediatePropagation();
                this.toggleCheatsheet();
                e.preventDefault();
            }
        });

        this.ngZone.runOutsideAngular(() => {
            // HACK: Get rid of this interval
            this._hotkeysInterval = setInterval(() => {
                if (this.showCheatsheet) {
                    this.collectHotkeys();
                }
            }, 500);
        });


        this.monEventService.addListener(MON_EVENTS.OPEN_UNIFIED_HOTKEYS_CHEATSHEET, () => {
            this.showCheatsheet = true;
        });
    }

    ngOnDestroy () {
        if (this.removeListener) {
            this.removeListener();
        }
        if (this._hotkeysInterval) {
            clearInterval(this._hotkeysInterval);
        }
    }


    toggleCheatsheet () {
        if (!this.showCheatsheet) {
            this.collectHotkeys();
        }
        this.showCheatsheet = !this.showCheatsheet;
    }

    closeCheatsheet () {
        if (this.showCheatsheet) {
            this.showCheatsheet = false;
        }
    }

    collectHotkeys () {
        const angularJsHotkeys = (window as any).angularJsHotkeys ?? [];

        const angularJsHotkeysFormatted = angularJsHotkeys
            .filter((hk: any) => hk.description)
            .map((hk: any) => ({ combo: this.format(hk.combo), description: hk.description }));

        let angularHotkeys = (this.hotkeysService.hotkeys || [])
            .filter(hk => hk.description)
            .map(hk => ({ combo: this.format(hk.combo), description: hk.description }));

        if (angularHotkeys.length > 0) {
            angularHotkeys = angularHotkeys.slice(1);
        }
        this.allHotkeys = [...angularJsHotkeysFormatted, ...angularHotkeys]
            .filter((v, i, a) => a.findIndex(t => t.combo === v.combo) === i);
    }

    format (combo: string | string[]): string {
        const combination = Array.isArray(combo) ? combo[0] : combo;
        const sequence = combination.split(' ');
        for (let i = 0; i < sequence.length; i++) {
            sequence[i] = this.symbolize(sequence[i]);
        }
        return sequence.join(' ');
    }

    symbolize (combo) {
        const map = {
            command: '\u2318', // ⌘
            shift: '\u21E7', // ⇧
            left: '\u2190', // ←
            right: '\u2192', // →
            up: '\u2191', // ↑
            down: '\u2193', // ↓
            'return': '\u23CE', // ⏎
            backspace: '\u232B', // ⌫
        };
        combo = combo.split('+');

        for (let i = 0; i < combo.length; i++) {
            if (combo[i] === 'mod') {
                if (window.navigator && /Mac/i.test(window.navigator.userAgent)) {
                    combo[i] = 'command';
                } else {
                    combo[i] = 'ctrl';
                }
            }

            combo[i] = map[combo[i]] ?? combo[i];
        }

        return combo.join(' + ');
    }
}
